<template>
  <div class="breakdown-card">
    <div class="w-full px-4 pt-2.5 pb-1 flex items-center justify-between">
      <BaseText type="label" size="sm" class="text-text-normal">
        Gender & Age Breakdown
      </BaseText>
      <!-- Metric Selector -->
      <GraphMetricSelector
        :selected-metric="selectedMetric"
        side="right"
        :shadow="false"
        :disable-selector="isDataPublic"
        @changeMetric="handleMetricChange"
      />
    </div>
    <!-- Male Female Key -->
    <div class="flex items-center gap-4 px-4 pb-6">
      <div class="flex items-center gap-1.5">
        <div class="w-2 h-2 rounded-sm" style="background-color: #0058CE" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Male
        </BaseText>
      </div>
      <div class="flex items-center gap-1.5">
        <div class="w-2 h-2 rounded-sm" style="background-color: #443190" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Female
        </BaseText>
      </div>
    </div>
    <div class="relative w-full pb-3">
      <transition>
        <div v-if="loading" class="absolute w-full h-full flex items-center justify-center z-50">
          <BaseLoadingSpinnerCircle class="mb-10 text-icon-normal" :width="24" :height="24" :duration="1" />
        </div>
      </transition>
      <MonoMetricBreakdownBarGraph 
        class="transition-opacity" :class="{ 'opacity-50': loading }"
        :selected-metric="selectedMetric" 
        :data-groups="dataGroups" 
        :currency-region="currencyRegion"
        :graph-x-padding="2"
        :bar-spacing="34"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GraphMetricSelector from './graphs/GraphMetricSelector.vue'
import MonoMetricBreakdownBarGraph from './graphs/MonoMetricBreakdownBarGraph.vue'

export default {
  name: 'GenderAgeBreakdown',
  components: {
    GraphMetricSelector,
    MonoMetricBreakdownBarGraph
  },
  props: {
    selectedMetric: {
      type: String,
      required: true
    },
    dataGroups: {
      type: Array,
      required: true
    },
    currencyRegion: {
      type: String,
      default: 'USD'
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDataPublic: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMetricSelector: false,
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricLookup'])
  },
  methods: {
    handleMetricChange (key) {
      this.$emit('changeMetric', key)
      this.showMetricSelector = false
    }
  }
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>